import Vue from "vue";
import Vuex from "vuex";
import { createDirectStore } from "direct-vuex";
import insurance from "@/store/InsuranceModule";
import info from "@/store/InfoModule";
import dicti from "@/store/DictiModule";
import iccalc from "@/store/ICCalcModule";
import { WidgetService } from "@/services/WidgetService";
import { serviceOptions, Widget } from "@/services/index.defs";
Vue.use(Vuex);

class AppState {
    widget: Widget = null;
    isAppLoading: boolean = false;
    showRecentCalc: boolean = true;
    ratelimitVisible: boolean = true;
}

const { store, rootActionContext, moduleActionContext } = createDirectStore({
    state: new AppState(),
    modules: {
        insurance,
        info,
        dicti,
        iccalc,
    },
    actions: {
        async loadWidget({ state }: { state: AppState }, id: number) {
            serviceOptions.axios.defaults.headers.common["widgetid"] = id;
            state.isAppLoading = true;
            const res = await WidgetService.widget();
            state.widget = res;
            state.isAppLoading = false;
        },
    },
    mutations: {
        setAppLoading(state: AppState, value: boolean) {
            state.isAppLoading = value;
        },
    },
    getters: {
        isFastCalcDisabled(state: AppState) {
            return state.widget?.isFastCalcDisabled;
        },
        priorityICSetting(state: AppState) {
            return state.widget?.insuranceProviderSettings ?? [];
        },
    },
});
export default store;
export { rootActionContext, moduleActionContext };
export type AppStore = typeof store;
declare module "vuex" {
    interface Store<S> {
        direct: AppStore;
    }
}
